"use client";

import { c as _c } from "react/compiler-runtime";
import { NFTSubscription, RedeemedSubscription, SubscriptionDetails, SubscriptionLog, SubscriptionTopUp } from "@/entities/ISubscription";
import { ApiIdentity } from "@/generated/models/ApiIdentity";
import { useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { AuthContext } from "@/components/auth/Auth";
import { getCardsRemainingUntilEndOf, isMintingToday } from "@/components/meme-calendar/meme-calendar.helpers";
import { Page } from "@/helpers/Types";
import { commonApiFetch } from "@/services/api/common-api";
import Link from "next/link";
import UserPageSubscriptionsAirdropAddress, { AirdropAddressResult } from "./UserPageSubscriptionsAirdropAddress";
import UserPageSubscriptionsBalance from "./UserPageSubscriptionsBalance";
import UserPageSubscriptionsHistory from "./UserPageSubscriptionsHistory";
import UserPageSubscriptionsMode from "./UserPageSubscriptionsMode";
import UserPageSubscriptionsTopUp from "./UserPageSubscriptionsTopUp";
import UserPageSubscriptionsUpcoming from "./UserPageSubscriptionsUpcoming";
const HISTORY_PAGE_SIZE = 10;
export default function UserPageSubscriptions(props) {
  const $ = _c(93);
  const {
    connectedProfile,
    activeProfileProxy
  } = useContext(AuthContext);
  const [profileKey, setProfileKey] = useState();
  const [isFetching, setIsFetching] = useState(true);
  const [details, setDetails] = useState();
  const [fetchingDetails, setFetchingDetails] = useState(true);
  const [airdropResult, setAirdropResult] = useState();
  const [fetchingAirdropAddress, setFetchingAirdropAddress] = useState(true);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      count: 0,
      page: 1,
      next: false,
      data: []
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const [topUpHistory, setTopUpHistory] = useState(t0);
  const [fetchingTopUpHistory, setFetchingTopUpHistory] = useState(true);
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      count: 0,
      page: 1,
      next: false,
      data: []
    };
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [redeemedHistory, setRedeemedHistory] = useState(t1);
  const [fetchingRedeemedHistory, setFetchingRedeemedHistory] = useState(true);
  const remainingMintsForSeason = getCardsRemainingUntilEndOf("szn");
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const [memeSubscriptions, setMemeSubscriptions] = useState(t2);
  const [fetchingMemeSubscriptions, setFetchingMemeSubscriptions] = useState(true);
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      count: 0,
      page: 1,
      next: false,
      data: []
    };
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const [subscriptionLogs, setSubscriptionLogs] = useState(t3);
  const [fetchingSubscriptionLogs, setFetchingSubscriptionLogs] = useState(true);
  const [isConnectedAccount, setIsConnectedAccount] = useState(false);
  let t4;
  if ($[4] !== activeProfileProxy || $[5] !== connectedProfile?.consolidation_key || $[6] !== connectedProfile?.wallets || $[7] !== props.profile) {
    t4 = () => {
      if (activeProfileProxy) {
        setIsConnectedAccount(false);
        setProfileKey(undefined);
        return;
      }
      const connectedKey = connectedProfile?.consolidation_key ?? connectedProfile?.wallets?.map(_temp).join("-");
      const pKey = props.profile.consolidation_key ?? props.profile.wallets?.map(_temp2).join("-");
      setIsConnectedAccount(connectedKey === pKey);
      setProfileKey(pKey);
    };
    $[4] = activeProfileProxy;
    $[5] = connectedProfile?.consolidation_key;
    $[6] = connectedProfile?.wallets;
    $[7] = props.profile;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== activeProfileProxy || $[10] !== connectedProfile || $[11] !== props.profile) {
    t5 = [connectedProfile, activeProfileProxy, props.profile];
    $[9] = activeProfileProxy;
    $[10] = connectedProfile;
    $[11] = props.profile;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  useEffect(t4, t5);
  let t6;
  if ($[13] !== fetchingAirdropAddress || $[14] !== fetchingDetails || $[15] !== fetchingMemeSubscriptions || $[16] !== fetchingRedeemedHistory || $[17] !== fetchingSubscriptionLogs || $[18] !== fetchingTopUpHistory) {
    t6 = () => {
      setIsFetching(fetchingDetails || fetchingAirdropAddress || fetchingTopUpHistory || fetchingMemeSubscriptions || fetchingSubscriptionLogs || fetchingRedeemedHistory);
    };
    $[13] = fetchingAirdropAddress;
    $[14] = fetchingDetails;
    $[15] = fetchingMemeSubscriptions;
    $[16] = fetchingRedeemedHistory;
    $[17] = fetchingSubscriptionLogs;
    $[18] = fetchingTopUpHistory;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  useEffect(t6, [fetchingDetails, fetchAirdropAddress, fetchingTopUpHistory, fetchingMemeSubscriptions, fetchingSubscriptionLogs, fetchingRedeemedHistory]);
  let t7;
  if ($[20] !== profileKey) {
    t7 = function fetchDetails() {
      if (!profileKey) {
        return;
      }
      setFetchingDetails(true);
      commonApiFetch({
        endpoint: `subscriptions/consolidation/details/${profileKey}`
      }).then(data => {
        setDetails(data);
      }).finally(() => {
        setFetchingDetails(false);
      });
    };
    $[20] = profileKey;
    $[21] = t7;
  } else {
    t7 = $[21];
  }
  const fetchDetails = t7;
  function fetchAirdropAddress() {
    if (!profileKey) {
      return;
    }
    setFetchingAirdropAddress(true);
    commonApiFetch({
      endpoint: `subscriptions/consolidation/${profileKey}/airdrop-address`
    }).then(data_0 => {
      setAirdropResult(data_0);
    }).finally(() => {
      setFetchingAirdropAddress(false);
    });
  }
  let t8;
  if ($[22] !== profileKey) {
    t8 = function fetchTopUpHistory(page) {
      if (!profileKey) {
        return;
      }
      setFetchingTopUpHistory(true);
      commonApiFetch({
        endpoint: `subscriptions/consolidation/top-up/${profileKey}?page=${page}&page_size=${HISTORY_PAGE_SIZE}`
      }).then(data_1 => {
        setTopUpHistory(data_1);
      }).finally(() => {
        setFetchingTopUpHistory(false);
      });
    };
    $[22] = profileKey;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  const fetchTopUpHistory = t8;
  let t9;
  if ($[24] !== profileKey) {
    t9 = function fetchRedeemHistory(page_0) {
      if (!profileKey) {
        return;
      }
      setFetchingRedeemedHistory(true);
      commonApiFetch({
        endpoint: `subscriptions/consolidation/redeemed/${profileKey}?page=${page_0}&page_size=${HISTORY_PAGE_SIZE}`
      }).then(data_2 => {
        setRedeemedHistory(data_2);
      }).finally(() => {
        setFetchingRedeemedHistory(false);
      });
    };
    $[24] = profileKey;
    $[25] = t9;
  } else {
    t9 = $[25];
  }
  const fetchRedeemHistory = t9;
  let t10;
  if ($[26] !== profileKey) {
    t10 = function fetchMemeSubscriptions() {
      if (!profileKey) {
        return;
      }
      setFetchingMemeSubscriptions(true);
      let upcomingLimit = remainingMintsForSeason;
      if (isMintingToday()) {
        upcomingLimit = upcomingLimit + 1;
      }
      commonApiFetch({
        endpoint: `subscriptions/consolidation/upcoming-memes/${profileKey}?card_count=${upcomingLimit}`
      }).then(data_3 => {
        setMemeSubscriptions(data_3);
      }).finally(() => {
        setFetchingMemeSubscriptions(false);
      });
    };
    $[26] = profileKey;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  const fetchMemeSubscriptions = t10;
  let t11;
  if ($[28] !== profileKey) {
    t11 = function fetchLogs(page_1) {
      if (!profileKey) {
        return;
      }
      setFetchingSubscriptionLogs(true);
      commonApiFetch({
        endpoint: `subscriptions/consolidation/logs/${profileKey}?page=${page_1}&page_size=${HISTORY_PAGE_SIZE}`
      }).then(data_4 => {
        setSubscriptionLogs(data_4);
      }).finally(() => {
        setFetchingSubscriptionLogs(false);
      });
    };
    $[28] = profileKey;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  const fetchLogs = t11;
  let t12;
  if ($[30] !== fetchAirdropAddress || $[31] !== fetchDetails || $[32] !== fetchLogs || $[33] !== fetchMemeSubscriptions || $[34] !== fetchRedeemHistory || $[35] !== fetchTopUpHistory || $[36] !== profileKey) {
    t12 = () => {
      if (!profileKey) {
        return;
      }
      fetchDetails();
      fetchAirdropAddress();
      fetchTopUpHistory(1);
      fetchMemeSubscriptions();
      fetchRedeemHistory(1);
      fetchLogs(1);
    };
    $[30] = fetchAirdropAddress;
    $[31] = fetchDetails;
    $[32] = fetchLogs;
    $[33] = fetchMemeSubscriptions;
    $[34] = fetchRedeemHistory;
    $[35] = fetchTopUpHistory;
    $[36] = profileKey;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  const refresh = t12;
  let t13;
  if ($[38] !== refresh) {
    t13 = () => {
      refresh();
    };
    $[38] = refresh;
    $[39] = t13;
  } else {
    t13 = $[39];
  }
  let t14;
  if ($[40] !== profileKey) {
    t14 = [profileKey];
    $[40] = profileKey;
    $[41] = t14;
  } else {
    t14 = $[41];
  }
  useEffect(t13, t14);
  if (!profileKey) {
    let t15;
    if ($[42] === Symbol.for("react.memo_cache_sentinel")) {
      t15 = <></>;
      $[42] = t15;
    } else {
      t15 = $[42];
    }
    return t15;
  }
  const t15 = isConnectedAccount ? 6 : 12;
  let t16;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <Row className="pb-2"><Col className="d-flex align-items-center gap-2"><h4 className="mb-0">Subscribe</h4><span><Link href="/about/subscriptions" className="font-smaller font-color-silver decoration-hover-underline">Learn More</Link></span></Col></Row>;
    $[43] = t16;
  } else {
    t16 = $[43];
  }
  const t17 = `pt-2 pb-2 d-flex ${isConnectedAccount ? "flex-column gap-4" : "flex-wrap flex-md-nowrap gap-4 justify-content-between"}`;
  let t18;
  if ($[44] !== details || $[45] !== isConnectedAccount || $[46] !== isFetching || $[47] !== refresh) {
    t18 = <UserPageSubscriptionsBalance details={details} fetching={isFetching} refresh={refresh} show_refresh={isConnectedAccount} />;
    $[44] = details;
    $[45] = isConnectedAccount;
    $[46] = isFetching;
    $[47] = refresh;
    $[48] = t18;
  } else {
    t18 = $[48];
  }
  const t19 = !isConnectedAccount;
  let t20;
  if ($[49] !== details || $[50] !== profileKey || $[51] !== refresh || $[52] !== t19) {
    t20 = <UserPageSubscriptionsMode profileKey={profileKey} details={details} readonly={t19} refresh={refresh} />;
    $[49] = details;
    $[50] = profileKey;
    $[51] = refresh;
    $[52] = t19;
    $[53] = t20;
  } else {
    t20 = $[53];
  }
  let t21;
  if ($[54] !== airdropResult || $[55] !== isConnectedAccount) {
    t21 = <UserPageSubscriptionsAirdropAddress show_edit={isConnectedAccount} airdrop={airdropResult} />;
    $[54] = airdropResult;
    $[55] = isConnectedAccount;
    $[56] = t21;
  } else {
    t21 = $[56];
  }
  let t22;
  if ($[57] !== t17 || $[58] !== t18 || $[59] !== t20 || $[60] !== t21) {
    t22 = <Container className="no-padding">{t16}<Row><Col className={t17}>{t18}{t20}{t21}</Col></Row></Container>;
    $[57] = t17;
    $[58] = t18;
    $[59] = t20;
    $[60] = t21;
    $[61] = t22;
  } else {
    t22 = $[61];
  }
  let t23;
  if ($[62] !== t15 || $[63] !== t22) {
    t23 = <Col sm={12} md={t15}>{t22}</Col>;
    $[62] = t15;
    $[63] = t22;
    $[64] = t23;
  } else {
    t23 = $[64];
  }
  let t24;
  if ($[65] !== isConnectedAccount) {
    t24 = isConnectedAccount && <Col sm={12} md={6}><UserPageSubscriptionsTopUp /></Col>;
    $[65] = isConnectedAccount;
    $[66] = t24;
  } else {
    t24 = $[66];
  }
  let t25;
  if ($[67] !== t23 || $[68] !== t24) {
    t25 = <Row className="pt-2 pb-2">{t23}{t24}</Row>;
    $[67] = t23;
    $[68] = t24;
    $[69] = t25;
  } else {
    t25 = $[69];
  }
  const t26 = !isConnectedAccount;
  let t27;
  if ($[70] !== details || $[71] !== memeSubscriptions || $[72] !== profileKey || $[73] !== refresh || $[74] !== t26) {
    t27 = <Row className="pt-4 pb-2"><Col><UserPageSubscriptionsUpcoming profileKey={profileKey} details={details} memes_subscriptions={memeSubscriptions} readonly={t26} refresh={refresh} /></Col></Row>;
    $[70] = details;
    $[71] = memeSubscriptions;
    $[72] = profileKey;
    $[73] = refresh;
    $[74] = t26;
    $[75] = t27;
  } else {
    t27 = $[75];
  }
  let t28;
  if ($[76] !== fetchRedeemHistory) {
    t28 = page_2 => {
      fetchRedeemHistory(page_2);
    };
    $[76] = fetchRedeemHistory;
    $[77] = t28;
  } else {
    t28 = $[77];
  }
  let t29;
  if ($[78] !== fetchTopUpHistory) {
    t29 = page_3 => {
      fetchTopUpHistory(page_3);
    };
    $[78] = fetchTopUpHistory;
    $[79] = t29;
  } else {
    t29 = $[79];
  }
  let t30;
  if ($[80] !== fetchLogs) {
    t30 = page_4 => {
      fetchLogs(page_4);
    };
    $[80] = fetchLogs;
    $[81] = t30;
  } else {
    t30 = $[81];
  }
  let t31;
  if ($[82] !== redeemedHistory || $[83] !== subscriptionLogs || $[84] !== t28 || $[85] !== t29 || $[86] !== t30 || $[87] !== topUpHistory) {
    t31 = <Row className="pt-2 pb-2"><Col><UserPageSubscriptionsHistory topups={topUpHistory} redeemed={redeemedHistory} logs={subscriptionLogs} setRedeemedPage={t28} setTopUpPage={t29} setLogsPage={t30} /></Col></Row>;
    $[82] = redeemedHistory;
    $[83] = subscriptionLogs;
    $[84] = t28;
    $[85] = t29;
    $[86] = t30;
    $[87] = topUpHistory;
    $[88] = t31;
  } else {
    t31 = $[88];
  }
  let t32;
  if ($[89] !== t25 || $[90] !== t27 || $[91] !== t31) {
    t32 = <Container className="no-padding pb-5">{t25}{t27}{t31}</Container>;
    $[89] = t25;
    $[90] = t27;
    $[91] = t31;
    $[92] = t32;
  } else {
    t32 = $[92];
  }
  return t32;
}
function _temp2(w_0) {
  return w_0.wallet;
}
function _temp(w) {
  return w.wallet;
}